import { Chip } from "@mui/material";
export const statusColors = {
  active: "success",
  approved: "success",
  accepted: "success",
  paid: "success",
  available: "success",
  delivered: "success",
  failed: "error",
  refunded: "default",
  inactive: "default",
  draft: "default",
  pending: "warning",
  busy: "warning",
  cooking: "info",
  preparing: "info",
  completed: "success",
  rejected: "error",
  cancelled: "error",
  canceled: "error",
  expired: "error",
  unpaid: "error",
  assigned: "info",
  processing: "info",
  "on the way": "info",
  "out for delivery": "info",
  packing: "warning",
  ready: "success",
};
export default function StatusBadge({ status, label, ...props }) {
  const key = String(status ?? label ?? "")
    .replace(/"/g, "")
    .trim()
    .toLowerCase();
  return (
    <Chip
      size="small"
      color={statusColors[key] || "default"}
      label={
        label ||
        (key
          ? key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ")
          : "Unknown")
      }
      {...props}
    />
  );
}
